'use client';

import { c as _c } from "react/compiler-runtime";
import DeviceIcons from '@/components/DeviceIcons';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useTranslations } from 'next-intl';
function WorldDeviceAvailable() {
  const $ = _c(11);
  const t = useTranslations();
  const {
    roomData
  } = useCheckEnterRoomContext();
  let t0;
  if ($[0] !== roomData.preferred_devices) {
    t0 = roomData.preferred_devices || [];
    $[0] = roomData.preferred_devices;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const preferredDevice = t0;
  let t1;
  if ($[2] !== t) {
    t1 = t("world-info.device-available");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <span className="caption text-vive-primary-30 w-[88px] shrink-0">{t1}</span>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== preferredDevice) {
    t3 = <div className="flex flex-1 flex-wrap items-center gap-2"><DeviceIcons deviceType={preferredDevice} containerClassName="md:gap-2" /></div>;
    $[6] = preferredDevice;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex w-full items-start gap-4 md:gap-8">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
export default WorldDeviceAvailable;